import type { AppError } from 'mini-app-context/lib/schema/AppError';
import { lazyGetWorkflowSignalManager } from '..';
import type { LogOptions } from 'telemetry';

export default async function signalWorkflow(
    name: string,
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    inputPayload?: any,
    options?: LogOptions,
    error?: AppError
): Promise<void> {
    const workflowManager = await lazyGetWorkflowSignalManager.importAndExecute();
    return workflowManager.signal(name, inputPayload, options, error);
}
